import styled from "styled-components";
import mediaBreakpoints from "../../constants/media-breakpoints";
import { colours } from "../../styles/colours.constants";
import { satoshi700, satoshi900 } from "../../styles/font.constants";

export const PageTabs = styled.div`
	display: flex;
	width: 100%;
	gap: 2rem;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;
	scroll-padding: 0 2rem;
	border-bottom: solid 1px #43434433;
	padding: 1rem 1rem 0 1rem;

	&::-webkit-scrollbar {
		display: none;
	}

	@media ${mediaBreakpoints.tablet} {
		gap: unset;
		justify-content: space-between;
		overflow-x: visible;
		padding: 0;
	}
`;

type TitleStyleProps = {
	$active: boolean;
};

export const TitleContainer = styled.div`
	flex: 0 0 auto;
	display: flex;
	justify-content: center;

	@media ${mediaBreakpoints.tablet} {
		flex: 1;
	}
`;

const getFont = (active: boolean) => {
	if (active) {
		return satoshi900;
	}

	return satoshi700;
};

export const Title = styled.div<TitleStyleProps>`
	${({ $active }) => getFont($active)};
	font-size: 1.25rem;
	letter-spacing: 2%;
	text-align: center;
	white-space: nowrap;
	padding-bottom: 0.7rem;
	cursor: ${({ $active }) => ($active ? "default" : "pointer")};
	opacity: ${({ $active }) => ($active ? 1 : 0.4)};
	border-bottom: ${({ $active }) =>
		$active ? `solid 5px ${colours.red}` : "none"};
`;
